var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProductsTable',{attrs:{"keys":_vm.keys,"items":_vm.basket,"totals":_vm.totals,"delivery":_vm.delivery,"actions":""},on:{"plus":_vm.basketPlus,"minus":_vm.basketMinus,"remove":_vm.basketRemove,"clear":_vm.basketClear}})
}
var staticRenderFns = []

export { render, staticRenderFns }